import { render } from "./OverviewNav.vue?vue&type=template&id=3ba0f43a&scoped=true"
import script from "./OverviewNav.vue?vue&type=script&lang=js"
export * from "./OverviewNav.vue?vue&type=script&lang=js"

import "./OverviewNav.vue?vue&type=style&index=0&id=3ba0f43a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba0f43a"]])

export default __exports__